// сборник цветов для приложения
export const colors={
    elements: '#078376',
    font_primary:'#333333',
    font_second:'#686868',
    header_font:'#333333',
    gray_block:'#e0e0e0',
    white: '#fff',
    status:{
        low:'#ff687b',
        medium:'#3982e0',
        high:'#078376'
    },
    progressBar:['#e8dd2f','#8ea5fd','#f87d83','#f79afc','#53f178','#7fecd1','#f2ba72', '#fffbbc', '#c7d3ff', '#ffb3b7', '#fcc9ff', '#b7f6b9', '#b2f4e3', '#ffd7a4']

}